"use client";

import { devLabel } from "@/lib/dev-labels";
import styles from "./NarrationPanel.module.css";

/**
 * ScriptEditor — Mode A custom-script textarea.
 *
 * Mockup source: docs/mockups/narration.html panel 24-E (Mode A
 * variant — the mockup shows the Mode B preview; Mode A surfaces the
 * raw textarea instead so the user can author the narration directly).
 */

const MAX_LEN = 5000;

export interface ScriptEditorProps {
	value: string;
	onChange: (s: string) => void;
}

export function ScriptEditor({ value, onChange }: ScriptEditorProps) {
	return (
		<div data-testid="script-editor">
			<div className={styles.sectionH} {...devLabel("24-E")}>
				<span>나레이션 스크립트 (직접 작성)</span>
				<span className={styles.sectionCount}>
					{value.length} / {MAX_LEN}
				</span>
			</div>
			<div className={styles.scriptBox} {...devLabel("24-E1")}>
				<label className={styles.srOnly} htmlFor="narration-script">
					나레이션 스크립트
				</label>
				<textarea
					id="narration-script"
					className={styles.scriptTextarea}
					value={value}
					onChange={(e) => onChange(e.target.value.slice(0, MAX_LEN))}
					placeholder="여기에 나레이션 텍스트를 입력하세요. 클립별로 단락을 나누면 더 자연스러운 더빙이 됩니다."
					rows={10}
					maxLength={MAX_LEN}
					data-testid="script-textarea"
				/>
			</div>
		</div>
	);
}
